import BaseCollectionService from "./base.collection.service";

class PropertyanalyticsService extends BaseCollectionService {
  constructor() {
    super("property-analytics");
  }
}

export default new PropertyanalyticsService();
